"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isIdentical = exports["default"] = void 0;
var _isArray = _interopRequireDefault(require("lodash/isArray"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * Shallow-equal compare of two arrays
 * @param {array} a0
 * @param {array} a1
 * @returns {boolean}
 */
var isIdentical = exports.isIdentical = function isIdentical(a0, a1) {
  if (!(0, _isArray["default"])(a0) || !(0, _isArray["default"])(a1)) {
    throw new TypeError('Both of the arguments have to be an array!');
  }
  if (a0.length !== a1.length) {
    return false;
  }
  for (var i = 0; i < a1.length; i++) {
    if (a0[i] !== a1[i]) {
      return false;
    }
  }
  return true;
};
var _default = exports["default"] = isIdentical;